module.exports = __webpack_public_path__ + "static/media/HCMM062.f2f55db2.jpg";